module.exports = __webpack_public_path__ + "img/40_68.642a9f79.png";